export const editorRole = "front_editor";
export const viewerRole = "front_viewer";
export const qualityRole = "quality";
export const resellerRole = "reseller";
export const csmRole = "csm";
export const csmMaintenanceRole = "csm_maintenance";
export const adminViewerRole = "admin_viewer";
export const adminEditorRole = "admin_editor";
export const techopsRole = "techops";
export const technicianRole = "technician";
export const developerRole = "developer";

export const configViewerRoles = [adminEditorRole, adminViewerRole, developerRole, technicianRole];

// Manager is deprecated in favour of Cockpit: only these roles keep access.
export const managerAccessRoles = [adminEditorRole, adminViewerRole, developerRole];

export const COCKPIT_STORES_URL = "https://cockpit.veesion.io/stores";

// Disabled unless REACT_APP_DEPRECATION_NOTICE_ENABLED is explicitly set to "true".
export function isDeprecationNoticeEnabled() {
  return process.env.REACT_APP_DEPRECATION_NOTICE_ENABLED === "true";
}

export const dashcamRoles = [
  adminEditorRole,
  adminViewerRole,
  technicianRole,
  techopsRole,
  csmRole,
  csmMaintenanceRole,
];

export const MINIMUM_RESOLUTION = 144;
export const MAXIMUM_RESOLUTION = 7680;

export const MAX_ANCHOR = 3000;

// Regex patterns for IP and hostname validation
// Supports IPv4 (with optional range syntax like 192.168.1.{23,22} or 192.168.1.{}), IPv6, and hostnames
export const ValidIpRegex =
  "^(?:(?:25[0-5]|2[0-4]\\d|1?\\d{1,2})\\.){3}(?:\\d{1,3}|\\{\\}|\\{\\d{1,3}(?:,\\d{1,3})*\\})$|\\[([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\\]|\\[([0-9a-fA-F]{1,4}:){1,7}:\\]|\\[:([0-9a-fA-F]{1,4}:){1,6}[0-9a-fA-F]{1,4}\\]|\\[([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}\\]|\\[([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}\\]|\\[([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}\\]|\\[([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}\\]|\\[([0-9a-fA-F]{1,4}:){1}(:[0-9a-fA-F]{1,4}){1,6}\\]|\\[:((:[0-9a-fA-F]{1,4}){1,7}|:)\\]|\\[fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}\\]$";

export const ValidHostnameRegex =
  "^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$";
